import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { LocalStorageService } from './local-storage';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoadingController, ToastController } from 'ionic-angular';
import { Photo } from '../model/photo';

@Injectable()
export class ImageService {
    private authHeaderName: string = 'Authorization';
    private authTokenPrefix: string = 'Bearer ';
    private authTokenStorageEntity: string = 'authtokens';

    constructor(
        private api: ApiService,
        private http: HttpClient,
        private localStorage: LocalStorageService,
        private loadingCtrl: LoadingController,
        private toast: ToastController) { }

    uploadImage(fileData, fileName, privateImage: boolean) {
        let loader = this.loadingCtrl.create({
            content: "Uploading image..."
        });
        loader.present();

        return new Promise((resolve, reject) => {
            this.localStorage.getEntity(this.authTokenStorageEntity)
                .then(tokens => {
                    var headers = new HttpHeaders();
                    headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);

                    let formData: FormData = new FormData();
                    formData.append('file', fileData, fileName)
                    console.log(formData);
                    this.http.post(this.api.endpoints.images + '/uploadImage?privateFile=' + privateImage, formData, { headers: headers })
                        .subscribe(data => {
                            loader.dismiss();
                            resolve(data);
                        }
                            , error => {
                                loader.dismiss();
                                reject(error);
                            });
                });
        });
    }

    uploadRunVideo(fileData, runId, fileName) {
        return new Promise((resolve, reject) => {
            this.localStorage.getEntity(this.authTokenStorageEntity)
                .then(tokens => {
                    var headers = new HttpHeaders();
                    headers = headers.append('Accept', 'application/json');
                    headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);

                    let formData: FormData = new FormData();
                    formData.append('file', fileData, fileName)
                    this.http.post(this.api.endpoints.images + '/uploadRunVideo?runId=' + runId, formData, { headers: headers })
                        .subscribe(data => {
                            resolve(data);
                        }
                            , error => {
                                reject(error);
                            });
                });
        });
    }

    uploadRunPhoto(file, fileName, runId): Promise<Photo> {
        return new Promise((resolve, reject) => {
            this.localStorage.getEntity(this.authTokenStorageEntity)
                .then(tokens => {
                    var headers = new HttpHeaders();
                    headers = headers.append('Accept', 'application/json');
                    headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);

                    let formData: FormData = new FormData();
                    formData.append('file', file, fileName);

                    this.http.post(this.api.endpoints.images + '/uploadRunPhoto?runId=' + runId, formData, { headers: headers })
                        .subscribe(data => {
                            resolve(data as Photo);
                        }
                            , error => {
                                reject(error);
                            });
                });
        });
    }

    uploadFile(file, fileName): Promise<string> {
        return new Promise((resolve, reject) => {
            this.localStorage.getEntity(this.authTokenStorageEntity)
                .then(tokens => {
                    var headers = new HttpHeaders();
                    headers = headers.append(this.authHeaderName, this.authTokenPrefix + tokens.accessToken);

                    let formData: FormData = new FormData();
                    formData.append('file', file, fileName);
                    console.log(formData);

                    this.http.post(this.api.endpoints.images + '/uploadFile', formData, { headers: headers })
                        .subscribe(data => {
                            resolve(data as string);
                        }
                            , error => {
                                reject(error);
                            });
                });
        });
    }

    updatePhoto(photo) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.images + '/update', photo)
                .then(data => resolve(data), error => reject(error));
        });
    }

    downloadPrivateImage(fileName) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.images + '/getPrivateImage?fileName=' + fileName)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteImage(fileName, privateFile: boolean) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.images + '/deleteImage?fileName=' + fileName + '&privateFile=' + privateFile)
                .then(data => resolve(data), error => reject(error));
        });
    }
    
    private showToast(customMessage: string, customColor: string) {
        this.toast.create({
          message: customMessage,
        //   color: customColor,
          duration: 2500,
        }).present();
      }
}



// WEBPACK FOOTER //
// ./src/services/image.service.ts